import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { ICON_LIBRARY } from "../icon-library";

import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";

/** The SVG of each icon of the library, by its name, from public.icon. */
export const useIconLibrary = (): UseSupabaseLoaderState<ReadonlyMap<string, string>> & {
  reload: () => void;
} =>
  useSupabaseLoader(async ({ supabase }) => {
    const { data, error } = await supabase
      .from("icon")
      .select("id, value")
      .in(
        "id",
        ICON_LIBRARY.map(({ name }) => name),
      );
    if (error) throw error;
    return new Map(data.map(({ id, value }) => [id, value]));
  }, []);
